import { TicketCommentModel } from "@jugl-web/rest-api/tickets/models/TicketComment";
import { Subject } from "rxjs";

export type TicketCommentMutationEvent =
  | { type: "created"; ticketId: string; comment: TicketCommentModel }
  | { type: "updated"; ticketId: string; comment: TicketCommentModel }
  | { type: "deleted"; ticketId: string; commentId: string };

const internalEvent$ = new Subject<TicketCommentMutationEvent>();

export const emitTicketCommentMutationEvent = (
  event: TicketCommentMutationEvent
) => {
  internalEvent$.next(event);
};

export const ticketCommentMutations$ = internalEvent$.asObservable();
